export default function Radio(theme) {
    return {
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: theme.palette.primary.darker,
                    '&.Mui-checked': {
                        color: theme.palette.primary.darker,
                    },
                    '& .MuiSvgIcon-root': {
                        fontSize: '24px',
                    },
                },
            }
        }
    };
}